import * as React from "react";
import { Switch, RouteComponentProps, Redirect } from "react-router-dom";
import { PrivateRoute } from "../app/privateRoute";
import { VehiclesMain } from "./vehicle/vehiclesMain";
import { GroupableVehiclesMain } from "./groupableVehicleReport/groupableVehicleMain";
import { GroupableWorkTimeWrapper } from "./groupableWorkTime/groupableWorkTimeWrapper";
import { FormSummaryView } from "./formSummaryView/formSummaryView";
import { OwnerParameters } from "../../models/owner/ownerParameters";
import { DriverLogMain } from "./driverLog/DriverLogMain";

export const ReportingBase = (props: RouteComponentProps) => {
    const ownerParameters = new OwnerParameters();

    return (
        <Switch>
            {ownerParameters.getOptionFormsEnabled() && (
                <PrivateRoute
                    path={`${props.match.path}/formsummary`}
                    component={FormSummaryView}
                />
            )}
            <PrivateRoute
                path={`${props.match.path}/groupable`}
                component={GroupableWorkTimeWrapper}
            />
            <PrivateRoute
                path={`${props.match.path}/vehicles`}
                component={VehiclesMain}
            />
            <PrivateRoute
                path={`${props.match.path}/groupableVehicles`}
                component={GroupableVehiclesMain}
            />
            <PrivateRoute
                path={`${props.match.path}/driverLog`}
                component={DriverLogMain}
            />
            <Redirect to={`${props.match.path}/groupable`} push />
        </Switch>
    );
};
